import { render, staticRenderFns } from "./DispatchModal.vue?vue&type=template&id=361c22ea&scoped=true"
import script from "./DispatchModal.vue?vue&type=script&lang=js"
export * from "./DispatchModal.vue?vue&type=script&lang=js"
import style0 from "./DispatchModal.vue?vue&type=style&index=0&id=361c22ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361c22ea",
  null
  
)

export default component.exports